enum FormStatus {
  Pristine,
  Dirty,
}

export default FormStatus;
